
window.oncontextmenu=function(e){
    e.preventDefault();
    return false;
}



  window.onunload = function(){
    localStorage.setItem('isSakerAccess','');
  }
  function getUrlParamNew(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
  }
  let utm_from = getUrlParamNew("utm_from") || "";
  let oseid = getUrlParamNew("oseid") || "";
  let tz = new Date().getTimezoneOffset() || -480;
  let lang = (navigator.language).toLowerCase() || "zh-cn";
  let isSakerAccess = localStorage.getItem('isSakerAccess') || "";
  var access_forbidden_browser = true
  var access_forbidden_east8 = false
  if(!isSakerAccess && !oseid && utm_from != 'saker'){
    if((access_forbidden_browser && lang == 'zh-cn') || (access_forbidden_east8 && tz == -480)){
      window.location="/pages/closed";
    }
  }
